import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { X, Megaphone } from "lucide-react";

const VARIANT_STYLES = {
  info: "bg-primary/10 border-primary/30 text-foreground",
  success: "bg-emerald-500/10 border-emerald-500/30 text-foreground",
  warning: "bg-amber-500/10 border-amber-500/30 text-foreground",
  critical: "bg-accent/10 border-accent/40 text-foreground",
};

export default function AnnouncementBanner() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return new Set(JSON.parse(localStorage.getItem("dismissedAnnouncements") || "[]")); }
    catch { return new Set(); }
  });

  useEffect(() => {
    api.get("/announcements/active").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const visible = items.filter((a) => !dismissed.has(a.announcement_id));
  if (!visible.length) return null;
  const a = visible[0];
  const dismiss = () => {
    const next = new Set(dismissed);
    next.add(a.announcement_id);
    setDismissed(next);
    localStorage.setItem("dismissedAnnouncements", JSON.stringify([...next]));
  };

  return (
    <div
      data-testid="announcement-banner"
      className={`relative z-30 border-b ${VARIANT_STYLES[a.variant] || VARIANT_STYLES.info}`}
    >
      <div className="max-w-[1400px] mx-auto flex items-center gap-3 px-4 md:px-8 py-2.5 text-sm">
        <Megaphone className="h-4 w-4 shrink-0" />
        <span className="font-semibold">{a.title}</span>
        <span className="text-muted-foreground hidden md:inline">— {a.message}</span>
        {a.action_url && (
          <a
            href={a.action_url}
            className="ml-auto text-xs font-mono uppercase tracking-widest underline underline-offset-4 hover:text-primary"
            data-testid="announcement-cta"
          >
            {a.action_label || "Learn more"}
          </a>
        )}
        {a.dismissible && (
          <button
            data-testid="dismiss-announcement"
            onClick={dismiss}
            className={`${a.action_url ? "" : "ml-auto"} p-1 rounded hover:bg-foreground/10`}
            aria-label="Dismiss"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}
